import { Typography } from "@mui/material";
import { useEffect, useState } from "react"
import './SimilarGigsSection.scss';
import GigListContainer from "../../GigListPageComponents/GigListContainer/GigListContainer";
import { GigAPIHandler } from "../../../../services/NetworkClient/BackendAPIs/GigAPIHandler";
import { ErrorLogger } from "../../../../utils/Logger";
import Gig from "../../../../Models/Gig";

interface SimilarGigsPropsInterface {
    subcategoryId?: string
    gigIdToExclude: string 
}

const SimilarGigsSection = ({subcategoryId, gigIdToExclude}: SimilarGigsPropsInterface) => {

    const [gigList, setGigList] = useState<Gig[]>([]);

    useEffect(() => {

        GigAPIHandler.shared.getGigsBySubcategory(subcategoryId as string, 1, 5).then( (gigResponse) => {
            setGigList(gigResponse.gigs.filter(gig  => {return gig.id !== gigIdToExclude}))
          }).catch((err) => { ErrorLogger.log(err, 'SimilarGigsSection'); })


    }, [gigIdToExclude, subcategoryId])


    return (
        <div className="similar-gigs-section">
            <Typography variant='h4' fontSize={{xs: "22px", md: "26px"}} fontWeight={700} className='heading' mb="16px" padding={"1.5rem 0 0 1.5rem"}> Similar Gigs </Typography>
            {gigList.length <= 0 ? 
                <Typography variant='h6' fontSize={{xs: "14px", md: "16px"}} fontWeight={500} mb="16px" className='center' padding={"1.5rem 0 0 1.5rem"}> No similar gigs found. </Typography> : 
                <GigListContainer gigList={gigList} />
            }

        </div>
    )
}

export default SimilarGigsSection